import React, { useEffect, useState } from 'react';
import { View, Modal } from 'react-native';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import FormActions from '../../../components/FormActions';
import { accessService } from '../../../services/central-api/access';
import MyPhoneInput from '../../../components/MyPhoneInput';
import { WindowInformation } from '../../../services/window-information';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface ModalProps {
    isModalVisible: boolean;
    onClose: () => void;
    internetCompanyId?: number;
}

export default function InternetCompanyModal({ isModalVisible, onClose, internetCompanyId }: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    const [name, setName] = useState('');
    const [phone, setPhone] = useState<string>('');
    const [responsible, setResponsible] = useState<string>('');

    async function getInternetCompany(id: number) {
        const internetCompany = await accessService.getInternetCompany(id);
        setName(internetCompany.name);
        setPhone(internetCompany.phone);
        setResponsible(internetCompany.responsible);
    }

    async function loadPageInfo() {
        try {
            if (internetCompanyId) {
                await getInternetCompany(internetCompanyId);
            }
        } catch (err) {
            console.error(err);
        }
    }

    function isFieldInvalid(value: string) {
        return value == '';
    }

    function isPhoneInvalid(value: string) {
        return value == '' || value.length < 10;
    }

    useEffect(() => {
        if (isModalVisible) {
            loadPageInfo();
        }
    }, [isModalVisible]);

    function isFormValid() {
        return !isFieldInvalid(name) && !isFieldInvalid(responsible) && !isPhoneInvalid(phone);
    }

    async function formSubmit() {
        try {
            if (internetCompanyId) {
                await accessService.updateInternetCompany({ id: internetCompanyId, name, phone, responsible });
            } else {
                await accessService.createInternetCompany({ name, phone, responsible });
            }
        } catch (err) {
            console.error(err);
        } finally {
            clearValues();
            onClose();
        }
    }

    function clearValues() {
        setName('');
        setPhone('');
        setResponsible('');
    }

    return (
        <Modal transparent={true}
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                clearValues();
                onClose();
            }}
        >
            <View style={styles.container}>
                <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: '20%' }]}>
                    <View style={{ rowGap: 10 }}>
                        <FormInput
                            label={translate('name')}
                            placeholder={translate('name')}
                            value={name}
                            onChangeText={setName}
                            invalid={isFieldInvalid}
                        />
                        <MyPhoneInput
                            label={translate('phone')}
                            placeholder={translate('phone')}
                            value={phone}
                            onChangeText={setPhone}
                            invalid={isPhoneInvalid}
                        />
                        <FormInput
                            label={translate('responsible')}
                            placeholder={translate('responsible')}
                            value={responsible}
                            onChangeText={setResponsible}
                            invalid={isFieldInvalid}
                        />
                    </View>
                    <FormActions
                        onSubmit={formSubmit}
                        onClose={() => {
                            clearValues();
                            onClose();
                        }}
                        disabled={!isFormValid()} />
                </View>
            </View>
        </Modal>

    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    formContainer: {
        minWidth: 300,
        minHeight: 150,
        backgroundColor: theme.colors.container.background,
        borderRadius: 4,
        padding: 20,
        rowGap: 25
    },
}));
